namespace TabAurous.Purchase {
    export namespace OrderService {
        export const baseUrl = 'Purchase/Order';

        export declare function Create(request: Serenity.SaveRequest<OrderRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OrderRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<OrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetLineNo(request: Serenity.ServiceRequest, onSuccess?: (response: GetLineNoResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<OrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/Order/Create",
            Update = "Purchase/Order/Update",
            Delete = "Purchase/Order/Delete",
            Retrieve = "Purchase/Order/Retrieve",
            List = "Purchase/Order/List",
            GetLineNo = "Purchase/Order/GetLineNo",
            PartyList = "Purchase/Order/PartyList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetLineNo', 
            'PartyList'
        ].forEach(x => {
            (<any>OrderService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
